<div
  *ngIf="hasInformativeNote"
  class="note-icon"
  nz-popover
  nzPopoverTrigger="hover"
  [nzPopoverTitle]="titleTemplate"
  [nzPopoverContent]="contentTemplate"
  (mouseover)="popoverType('informative')"
  nzPopoverPlacement="bottom"
  [nzPopoverOverlayClassName]="'company-note-popover'"
>
  <!-- informative note -->
  <va-icon size="small" name="info-circle" class="notes-icon"></va-icon>
</div>
<div
  *ngIf="hasCriticalNote"
  class="note-icon"
  nz-popover
  nzPopoverTrigger="hover"
  [nzPopoverTitle]="titleTemplate"
  nzPopoverPlacement="bottom"
  [nzPopoverContent]="contentTemplate"
  (mouseover)="popoverType('critical')"
  [nzPopoverOverlayClassName]="'company-note-popover'"
>
  <!-- critical note -->
  <va-icon name="exclamation-triangle"></va-icon>
</div>
<ng-template #titleTemplate>
  <div class="notes-header">
    <span class="notes-header-span">Notes ({{ currentNotes.length }})</span>
  </div>
</ng-template>
<ng-template #contentTemplate>
  <div class="notes-body">
    <table class="notes-table">
      <tr *ngFor="let item of currentNotes">
        <td class="creation-time">{{ item.creation_time }}</td>
        <td class="text" [innerHTML]="item.text"></td>
      </tr>
    </table>

    <div class="give-to-get" *ngIf="currentNotes.giveToGet">
      <span class="give_to_get_note">
        <va-icon name="star"></va-icon>
        &nbsp;Additional sources enabled by
        <a href="#" disabled="disabled">"Give-to-Get"</a>
      </span>
    </div>
  </div>
</ng-template>
